import { ExecutionOverviewViewComponent } from "../components/execution-results-view/execution-overview-view/execution-overview-view.component";
import { AgentRegistryComponent } from "./agent-registry/agent-registry.component";
import { CatalogueAgenticAIComponent } from "./agentic-AI/catalogue-agentic-ai/catalogue-agentic-ai.component";
import { OverviewAgenticAIComponent } from "./agentic-AI/overview-agentic-ai/overview-agentic-ai.component";
import { WorkspaceAgenticAIComponent } from "./agentic-AI/workspace-agentic-ai/workspace-agentic-ai.component";
import { AutomaticScriptGeneratorComponent } from "./automatic-script-generator/automatic-script-generator.component";
import { ApiServiceComponent } from "./automation-DTA/api-service/api-service.component";
import { ApplicationOverviewComponent } from "./automation-DTA/application-overview/application-overview.component";
import { ApplicationsComponent } from "./automation-DTA/applications/applications.component";
import { AutomationProjectOverviewComponent } from "./automation-DTA/automation-project-overview/automation-project-overview.component";
import { DataConnectionComponent } from "./automation-DTA/data-connection/data-connection.component";
import { PageComponent } from "./automation-DTA/page/page.component";
import { RestServiceOperationsViewComponent } from "./automation-DTA/rest-service-operations-view/rest-service-operations-view.component";
import { RestServiceOverviewComponent } from "./automation-DTA/rest-service-overview/rest-service-overview.component";
import { ReusableComponentsComponent } from "./automation-DTA/reusable-components/reusable-components.component";
import { StandardTestSuiteComponent } from "./automation-DTA/standard-test-suite/standard-test-suite.component";
import { SmartTestReviewReportComponent } from "./dashboard/smart-test-review-report/smart-test-review-report.component";
import { TestReportSummarizationComponent } from "./dashboard/test-report-summarization/test-report-summarization.component";
import { DefaultLayoutComponent } from "./default-layout/default-layout.component";
import { DevicesRegistryComponent } from "./devices-registry/devices-registry.component";
import { EditorTestScriptComponent } from "./editor-components/editor-test-script/editor-test-script.component";
import { ExecutionManagementComponent } from "./execution-management/execution-management.component";
import { OverviewComponent } from "./overview/overview/overview.component";
import { ProjectSettingsComponent } from "./project-settings/project-settings/project-settings.component";
import { ReleaseComponent } from "./project-settings/release/release.component";
import { ScriptExecutorComponent } from "./script-executor/script-executor.component";
import { TestExecutionResultsComponent } from "./test-execution-results/test-execution-results.component";
import { CodeMappingsComponent } from "./workflow/code-mappings/code-mappings.component";
import { ImpactfulTestCaseComponent } from "./workflow/impactful-test-case/impactful-test-case.component";
import { LlmDrivenFrameworkComponent } from "./workflow/llm-driven-framework/llm-driven-framework.component";
import { SmartTestReviewAutomatedComponent } from "./workflow/smart-test-review-automated/smart-test-review-automated.component";
import { SmartTestReviewManualComponent } from "./workflow/smart-test-review-manual/smart-test-review-manual.component";
import { TcgComponent } from "./workflow/tcg/tcg.component";
import { TdgComponent } from "./workflow/tdg/tdg.component";
import { TestCaseOptimizerComponent } from "./workflow/test-case-optimizer/test-case-optimizer.component";

export const Layouts = {
  TestReportSummarizerView: TestReportSummarizationComponent,
  ProjectSettingsView: ProjectSettingsComponent,
  ConnectionView: ProjectSettingsComponent,
  DefaultLayoutView: DefaultLayoutComponent,
  ManageApplicationsView: ProjectSettingsComponent,
  TestCaseGeneratorView: TcgComponent,
  SmartTestReviewManualView: SmartTestReviewManualComponent,
  SmartTestReviewAutomatedView: SmartTestReviewAutomatedComponent,
  TestPrioritizationAndSelectionView: ImpactfulTestCaseComponent,
  SmartTestReviewReportView: SmartTestReviewReportComponent,
  TestCaseOptimizerView: TestCaseOptimizerComponent,
  editorTestScript: EditorTestScriptComponent,
  OverviewView: OverviewComponent,
  TestCaseCodeMappingsView: CodeMappingsComponent,
  ImpactedTestCasesView: ImpactfulTestCaseComponent,
  TestExecutionView: TestExecutionResultsComponent,
  ScriptGeneratorView: AutomaticScriptGeneratorComponent,
  ScriptExecutorView: ScriptExecutorComponent,
  AgentRegistryView: AgentRegistryComponent,
  automationProjectView: AutomationProjectOverviewComponent,
  applicationOverviewView: ApplicationOverviewComponent,
  dataConnectionView: DataConnectionComponent,
  applicationsView: ApplicationsComponent,
  pageView: PageComponent,
  reusableComponentView: ReusableComponentsComponent,
  reusableTestScriptView: ReusableComponentsComponent,
  standardTestSuiteView: StandardTestSuiteComponent,
  testScriptView: StandardTestSuiteComponent,
  testSuiteView: StandardTestSuiteComponent,
  ExecutionManagementView:ExecutionManagementComponent,
  ReleasesView:ReleaseComponent,
  LLMDrivenFrameworkView: LlmDrivenFrameworkComponent,
  TestDataGenerationView: TdgComponent,
  apiServiceView: ApiServiceComponent,
  restServiceOverviewView: RestServiceOverviewComponent,
  restOperationsView: RestServiceOperationsViewComponent,
  DeviceRegistryView: DevicesRegistryComponent,
  OverviewAgenticAIView: OverviewAgenticAIComponent,
  WorkspaceAgenticAIView: WorkspaceAgenticAIComponent,
  CatalogueAgenticAIView: CatalogueAgenticAIComponent,
  TestExecutionResultsView: ExecutionOverviewViewComponent,
  TCGView: TcgComponent
};
